export default __webpack_public_path__ + "static/media/tripsha-logo-nobeta.876a6351.png";